import tippy from "tippy.js";

const Tooltip = {};

Tooltip.init = () => {

    tippy(document.querySelectorAll('.tooltip__icon'), {
        animation: 'shift-away-subtle',
        arrow: true,
        allowHTML: true,
        theme: 'custom',
    });

    tippy(document.querySelectorAll('.tooltip__icon-negative, .background__primary .tooltip__icon'), {
        animation: 'shift-away-subtle',
        arrow: true,
        allowHTML: true,
        theme: 'custom-negative',
    });
};

export default Tooltip;
